var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0129 0.700031C19.6046 0.700031 18.4629 1.8417 18.4629 3.25003V13.0467H19.9629V3.25003C19.9629 2.67013 20.433 2.20003 21.0129 2.20003H23.183V0.700031H21.0129Z",
    fill: "#1368FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 0.65332V2.04994H33.8002V0.65332H32.3002Z",
    fill: "#FF5468"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 3.54996V13.0466H33.8002V3.54996H32.3002Z",
    fill: "#1368FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2338 6.39158H20.9987V13.0467H22.4987V6.39158H23.183V4.89158H20.2338V6.39158Z",
    fill: "#1368FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 6.06074V6.98736H13.0875V8.48736H14.833V10.8481C14.833 11.2623 14.4972 11.5981 14.083 11.5981H13.7681V13.0981H14.083C15.3257 13.0981 16.333 12.0907 16.333 10.8481V8.48736H17.9651V6.98736H16.333V6.06074H14.833Z",
    fill: "#1368FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7912 8.99482V10.9509H14.2912V8.99482H12.7912Z",
    fill: "#1368FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.648 8.99482V10.9509H18.148V8.99482H16.648Z",
    fill: "#1368FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6465 0.751402V1.11915H13.0875V2.61915H17.8517V1.11915H16.1465V0.751402H14.6465Z",
    fill: "#1368FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.753 3.73905L13.8362 3.84157C13.9983 4.0412 14.1861 4.2049 14.3902 4.33267H12.7472V5.83267H18.192V4.33267H16.7758C16.98 4.2049 17.1678 4.0412 17.3298 3.84157L17.4131 3.73905L16.2485 2.79361L16.1653 2.89613C15.8651 3.26583 15.3009 3.26583 15.0008 2.89613L14.9175 2.79361L13.753 3.73905Z",
    fill: "#1368FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5502 0.699957H27.0502L24.5002 12.8979H25.9831L26.7183 9.51336H28.4002L28.1002 8.01335H27.0442L27.8594 4.26063L30.0735 12.9244L31.5502 12.8979L28.5502 0.699957Z",
    fill: "#1368FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21214 0.81914V12.7775H8.11885C10.0242 12.7775 11.5689 11.2328 11.5689 9.32745V0.81914H6.21214ZM7.71213 11.2775V2.31914H10.0689V9.32745C10.0689 10.4044 9.19581 11.2775 8.11885 11.2775H7.71213Z",
    fill: "#1368FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 0.891112V3.45745H5.37408V1.95745H1.7002V0.891112H0.200195Z",
    fill: "#FF5468"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 5.86956H2.09199V5.04999H3.59199V5.86956H5.37408V7.36956H0.200195V5.86956Z",
    fill: "#1368FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58839 7.92261L0.283913 12.3817L1.61648 13.0704L3.24932 9.91088L4.82264 10.6747L5.47772 9.32527L2.58839 7.92261Z",
    fill: "#1368FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.7a65a90ab53497c88ca821d1c3202214.svg";
export { ForwardRef as ReactComponent };